import React, { FC, memo } from 'react';
import { LuvImage } from '@/components/ui';
import { TypeUgcComponentRowFields } from '@/core/generated-types';

const UgcComponentRow: FC<TypeUgcComponentRowFields> = ({
  title,
  hashTag,
  id,
  components,
  backgroundColor,
}) => {
  return (
    <div id={id} className={`bg-${backgroundColor?.fields?.color} py-16`}>
      <div className="mx-auto mb-6 flex flex-col gap-4 text-center">
        <h2 className="text-[32px] font-bold">{title}</h2>
        <p className="font-bold tracking-widest">{hashTag}</p>
      </div>

      <div className="mx-auto mb-10 grid max-w-[328px] grid-cols-2 gap-2 px-1 sm:px-0 md:mb-20 md:max-w-[1128px] md:grid-cols-4 md:gap-6 md:px-4">
        {components?.map((c) => {
          const {
            fields: { Image, altText },
            sys: { id },
          } = c;
          return (
            <LuvImage
              key={id}
              Image={Image}
              altText={altText}
              width={264}
              height={264}
            />
          );
        })}
      </div>
    </div>
  );
};

export default memo(UgcComponentRow);
